import React, { FC } from 'react'

import { Text } from '@interco/inter-ui/components/Text'

import { DescriptionSection, OffersAndNewsContainer } from './styles'

type OffersAndNewsProps = {
  description: string
  title?: string
}

export const OffersAndNews: FC<OffersAndNewsProps> = ({ description, title }) => (
  <OffersAndNewsContainer>
    <DescriptionSection>
      {title && (
        <Text variant="headline-h3" color="typography" colorWeight={500} semiBold as="p">
          {title}
        </Text>
      )}
      <Text variant="body-3" color="typography" colorWeight={400} as="p">
        {description}
      </Text>
    </DescriptionSection>
  </OffersAndNewsContainer>
)
